import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Record a manual inventory adjustment via the recordInventoryAdjustmentV2
 * Cloud Function. Callers are unchanged — createdBy is dropped here because
 * the Cloud Function reads the caller's identity from the auth token directly.
 *
 * @param {{
 *   productDocId: string,
 *   productVersionId: string,
 *   sku: string,
 *   type: string,
 *   deltaOnHand: number,
 *   reason?: string,
 *   travelerIds?: string[],
 * }} params
 */
export default async function recordInventoryAdjustment({
  productDocId,
  productVersionId,
  sku,
  type,
  deltaOnHand,
  reason,
  travelerIds = [],
}) {
  const fn = httpsCallable(getFunctions(), 'recordInventoryAdjustmentV2');
  await fn({
    productDocId,
    productVersionId,
    sku,
    type,
    deltaOnHand,
    reason,
    travelerIds,
  });
}
